import './electric-banner.css';
import plug from "../../icons/icon/plug.svg"
export default function ElectricBannerComponent({ text="Scegli l'elettrico e metti al sicuro il tuo futuro contro l'aumento del gas!"}) {
    return (
        <div className={`electric-banner d-flex align-items-center justify-content-start p-2 mb-4`}>
            <img src={plug} alt="Plug icon" className="electric-banner-icon mx-4" />
            <div className="electric-banner-text bold small">
                {text}
            </div>
        </div>
    );
}